import * as z from 'zod'

// Naming follows the conventions established in the WebGL package.
// Ref: https://github.com/github/brand-refactor-webgl
export const BrandEnum = z.enum(['Mona', 'Copilot', 'Security', 'General'])
export type Brand = z.infer<typeof BrandEnum>
